export const DEFAULT_AUTOSAVE_INTERVAL_SECONDS = 3;
export const FOUR_MEGABYTES = 65536;
